import { cn } from '@/lib/utils';

interface NumberPadProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  formatDisplay?: boolean;
}

const MAX_LENGTH = 6;

export function NumberPad({ value, onChange, placeholder, formatDisplay = true }: NumberPadProps) {
  const displayValue =
    formatDisplay && value ? Number(value).toLocaleString() : value || placeholder || '0';

  function handleDigit(digit: string) {
    if (value.length >= MAX_LENGTH) return;
    onChange(value + digit);
  }

  function handleBackspace() {
    onChange(value.slice(0, -1));
  }

  const btnClass = cn(
    'flex items-center justify-center rounded-lg bg-ndd-800 text-xl font-bold',
    'h-14 active:bg-ndd-600 hover:bg-ndd-700 transition-colors select-none touch-manipulation'
  );

  return (
    <div className="space-y-3">
      {/* Display */}
      <div className="rounded-lg bg-ndd-950 px-4 py-4 text-center">
        <span className={cn('text-3xl font-bold tabular-nums', !value && 'text-ndd-600')}>
          {displayValue}
        </span>
      </div>

      {/* Pad */}
      <div className="grid grid-cols-3 gap-2">
        {['7', '8', '9', '4', '5', '6', '1', '2', '3'].map((digit) => (
          <button key={digit} type="button" className={btnClass} onClick={() => handleDigit(digit)}>
            {digit}
          </button>
        ))}
        {/* Bottom row: 0 (wide) + backspace */}
        <button
          type="button"
          className={cn(btnClass, 'col-span-2')}
          onClick={() => handleDigit('0')}
        >
          0
        </button>
        <button type="button" className={btnClass} onClick={handleBackspace} aria-label="Backspace">
          ⌫
        </button>
      </div>
    </div>
  );
}
